/* eslint-disable vue/max-len */
import JwtBaseClient from './JwtBaseClient';

class TransportGatewayClient {
  constructor() {
    this.jwtBaseClient = new JwtBaseClient(import.meta.env.VITE_TRANSPORT_MARKETPLACE_GATEWAY_BASE_URI, 'response.data');
    this.transportQuoteAuction = '/api/v1/transport-quote/auction';
    this.fetchTransportPromo = '/api/v1/transport-promo/marketplace';
  }

  /**
   * Retrieves transport quotes based on the provided payload and query parameters.
   *
   * @param {Object} payload - The request body containing the data for the quote search.
   * @param {string} payload.auctionId - The auction ID.
   * @param {string} payload.dealerId - The ID of current user's Dealer.
   * @param {string} [payload.addressId] - The ID of the address (optional).
   * @param {Boolean} payload.includeServiceType - flag if returned quotes include servicetype
   * @param {Object} queryParams - The query parameters for pagination and sorting.
   * @param {number} [queryParams.page] - The page number for pagination.
   * @param {number} [queryParams.size] - The number of items per page.
   * @param {string} [queryParams.sort] - The sorting criteria.
   * @returns returns either a paginated list of quotes or one quote if an address id is provided
   */
  getQuotes(payload, acvUserId) {
    return this.jwtBaseClient.post(`${this.transportQuoteAuction}`, payload, { 'acv-user-id': acvUserId });
  }

  /**
   * Fetches transport promo discounts for one or more auctions.
   *
   * @param {Object} payload
   * @param {number[]} payload.auctionIds - Auction IDs to retrieve promos for.
   * @returns {Promise<{data: {content: Array<{auctionId: number,
   *   id: number|null, discountFixedAmount: number|null,
   *   discountPercentage: number|null}>}}>}
   */
  fetchTransportPromos(payload) {
    return this.jwtBaseClient.post(`${this.fetchTransportPromo}`, payload);
  }
}
export default TransportGatewayClient;
